import { render } from "./OrdersHistoryOrderProduct.vue?vue&type=template&id=5e8d4e66"
import script from "./OrdersHistoryOrderProduct.vue?vue&type=script&lang=js"
export * from "./OrdersHistoryOrderProduct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__